import { post } from "api/action/base.js";
import {SentactFeedbackHttpError} from "util/SentactFeedbackHttpError.js";
import { getErrorMessage } from "util/ErrorCodes.js";

const postPerformedSurvey = (
    data,
    patientData,
    params={},
) => {
    if (Object.keys(patientData).length !== 0) {
        data['patientSnapshot'] = patientData;
    }
    delete data.name;
    return post('performed-surveys', data, params)
        .catch(error => {
            throw new SentactFeedbackHttpError(getErrorMessage(error.code), error.code, error);
        });
}

export default postPerformedSurvey;
